import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { ArrayOfKeys } from '../../../model/ArrayOfKeys';
import { UtilityService } from '../../../services/utility-service';
import {Constants} from '../../../constants/ebtq-constants';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionQuerySearchCriteria } from '../../../model/models';
import { TransactionWrapperData } from '../../../model/transactionWrapperData';
import {Title} from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-query-transactions',
  templateUrl: './query-transactions.component.html',
  styleUrls: ['./query-transactions.component.scss']
})
export class QueryTransactionsComponent implements OnInit, OnDestroy {

  private errorSub: Subscription;
  warningMessage: string;
  errorMessage: string[] = [];
  text = 'text';
  containsError = false;
  errorMsg: string;
  navigateToQueryLoans: string;

  utilService: UtilityService;
  service: ApiService;
  router: Router;

  effectiveDateTo: Date;
  effectiveDateFrom: Date;

  postingDateFrom: Date;
  postingDateTo: Date;

  title = 'Submit Transaction Query';

  //effectiveDateFrom

  sortBy: any[];
  selectedOrder = '';

  productType: any[];
  selectedProductType = 'ALL';

  actionCode: any[];
  selectedActionCode = 'ALL';

  transactionStatus: any[];
  selectedTransactionStatus = 'ALL';

  tranDesignator: any[];
  selectedTransactionDesignator = 'ALL';

  queryTransactionForm: UntypedFormGroup;
  keys: any[];
  mainPage: string;
  loanResultKeys: any;
  serNumber: any[];
  isExternal:boolean;
  fromPerformTrans: boolean;
  subPage: string;
  constructor(apiService: ApiService, router: Router, private errorService: ErrorService, private activatedRouter: ActivatedRoute, private titleService: Title, private cdr: ChangeDetectorRef) {
    this.utilService = new UtilityService();
    this.service = apiService;
    this.router = router;

    this.transactionStatus = this.utilService.transactionStatus;
    this.productType = this.utilService.productCode;
    this.actionCode = this.utilService.actionCode;
    this.tranDesignator = this.utilService.tranDesignator;

    this.queryTransactionForm = new UntypedFormGroup({

      loanNumber: new UntypedFormControl(''),
      servicerNumber: new UntypedFormControl(''),
      transactionStatus: new UntypedFormControl('ALL'),
      productType: new UntypedFormControl('ALL'),
      actionCode: new UntypedFormControl('ALL'),
      tranDesignator: new UntypedFormControl('ALL'),
      effectiveDateFrom: new UntypedFormControl(''),
      effectiveDateTo: new UntypedFormControl(''),
      postingDateFrom: new UntypedFormControl(''),
      postingDateTo: new UntypedFormControl(''),
      sortBy: new UntypedFormControl('')
    });

    this.sortBy = [];
    this.sortBy.push({ label: 'Servicer Number', value: '1' });
    this.sortBy.push({ label: 'Fannie Mae Loan Number', value: '2' });
    this.sortBy.push({ label: 'Product Type', value: '3' });
    this.sortBy.push({ label: 'Effective Date', value: '4' });
    this.sortBy.push({ label: 'Creation Date', value: '5' });
    this.sortBy.push({ label: 'Transaction Type', value: '6' });
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.warningMessage = '';
    this.queryTransactionForm.reset();
    this.mainPage = 'queryTransactions';
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.activatedRouter.queryParams.subscribe(params => {
      if (params.loanNumber !== undefined) {
        this.mainPage =  params.mainPage;
        this.navigateToQueryLoans = params.loanNumber;
        this.loanResultKeys = params.loanResult;
        this.keys = params.Keys;
        this.fromPerformTrans = params.fromPerformTrans;

        this.subPage = params.subPage;
        this.queryTransactionForm.patchValue(
          {
            loanNumber:params.loanNumber
          }
        );
        this.queryTransationList();
      }
    });


    this.serNumber = [];

    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternal = (this.isExternal == null) ? false : this.isExternal;

    if (this.isExternal &&  (sessionStorage.getItem('authServrList') != null))
    {
      const authServrList = Array.from(JSON.parse(sessionStorage.getItem('authServrList')));
      this.serNumber.push({label: 'ALL', value: ''});
      for (let i = 0; i < authServrList.length; i++) {
        this.serNumber.push(authServrList[i]);
      }
      this.queryTransactionForm.controls['servicerNumber'].setValue(this.serNumber[0].value);
    }

    this.cdr.detectChanges();
  }

  onClear(): void {
    this.queryTransactionForm.reset();
    this.errorMessage = [];
    this.warningMessage = '';
  }

  public queryTransationList(): void {
    this.warningMessage = '';
    this.errorMessage = [];

    let arrayOfkeys: ArrayOfKeys;
    let transactionQuerySearchCriteria = new TransactionQuerySearchCriteria();
    const transactionWrapper = new TransactionWrapper();
    transactionQuerySearchCriteria = this.queryTransactionForm.value;
    /** Converting date format to mm/dd/yyy */
    if (transactionQuerySearchCriteria.effectiveDateFrom != null && transactionQuerySearchCriteria.effectiveDateFrom !== '') {
      transactionQuerySearchCriteria.effectiveDateFrom = this.utilService.convertMillisecToDate(transactionQuerySearchCriteria.effectiveDateFrom);
    } else {
      transactionQuerySearchCriteria.effectiveDateFrom = null;
    }

    if (transactionQuerySearchCriteria.effectiveDateTo != null && transactionQuerySearchCriteria.effectiveDateTo !== '') {
      transactionQuerySearchCriteria.effectiveDateTo = this.utilService.convertMillisecToDate(transactionQuerySearchCriteria.effectiveDateTo);
    } else {
      transactionQuerySearchCriteria.effectiveDateTo = null;
    }

    if (transactionQuerySearchCriteria.postingDateFrom != null && transactionQuerySearchCriteria.postingDateFrom !== '') {
      transactionQuerySearchCriteria.postingDateFrom = this.utilService.convertMillisecToDate(transactionQuerySearchCriteria.postingDateFrom);
    } else {
      transactionQuerySearchCriteria.postingDateFrom = null;
    }

    if (transactionQuerySearchCriteria.postingDateTo != null && transactionQuerySearchCriteria.postingDateTo !== '') {
      transactionQuerySearchCriteria.postingDateTo = this.utilService.convertMillisecToDate(transactionQuerySearchCriteria.postingDateTo);
    } else {
      transactionQuerySearchCriteria.postingDateTo = null;
    }

    /** validate search form data */
    this.errorMessage = this.validateForm(transactionQuerySearchCriteria);

    transactionWrapper.parameters[0] = transactionQuerySearchCriteria;
    transactionWrapper.queryServiceName = Constants.GET_TRAN_QUERY_ALL_PKS;

    /** When there is validation message , it stop here */
    if (this.errorMessage.length > 0) {
      return;
    }

    /** Requesting data */
    // this.service.getTransmissionList(transactionWrapper).subscribe(
    this.service.executeQuery(transactionWrapper).subscribe(
      (data: Array<any>) => {
        const dataObjects = Object.values(data)[6];

        if (dataObjects == null || dataObjects === 0) {
          this.warningMessage = Constants.NO_DATA_MESSAGE;
          this.cdr.detectChanges();
          return;
        }
        if (dataObjects != null && dataObjects !== 0 && dataObjects[0].hasOwnProperty('SRVR_NO')) {
          const srvrNo = dataObjects[0].SRVR_NO;
          if (!this.utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
            console.log('The service number doesnt belong to the logged in user');
            this.warningMessage = Constants.NO_DATA_MESSAGE;
            this.cdr.detectChanges();
            return;
          }
        }
        if (dataObjects != null && Object.entries(dataObjects).length > 500 && !this.fromPerformTrans) {
          this.warningMessage = Constants.RESULT_WARNING;
          this.cdr.detectChanges();
          return;
        }
        arrayOfkeys = new ArrayOfKeys();
        arrayOfkeys.keys = Array.from(dataObjects, function(map) {
          return map['TRAN_ID'];
        });
        transactionWrapper.parameters[1] = arrayOfkeys.keys;
        const transactionWrapperData  = new TransactionWrapperData;
        transactionWrapperData.transactionWrapper = transactionWrapper;
        transactionWrapperData.callingServiceName = 'queryTransactions';

        /** Routing to result page when there are matching records. passing list of matching keys to get results */
        this.router.navigate(['transactionsResults'], {
          queryParams: {query: btoa(JSON.stringify(transactionWrapperData)),
            navigate:this.navigateToQueryLoans,
            keys: this.keys,
            mainPage: this.mainPage,
            loanResult: this.loanResultKeys,
            subPage:this.subPage}
        });

      },
      error => {
        if (error.includes('504'))
        {
          this.warningMessage = Constants.QUERY_SEARCH_TAKING_LONG_WARNING;
          this.cdr.detectChanges();
          return;
        } else {
          this.errorService.announceError(error);
        }
      }
    );

    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  /**  Validate FormModel according to business needs, return possible error to user*/
  private validateForm(transactionQuerySearchCriteria: TransactionQuerySearchCriteria): string[] {
    const errorMessages: string[] = [];

    /** Either Loan number of Servicer Number is required */
    const loanNumber = transactionQuerySearchCriteria.loanNumber;
    const servicerNumber = transactionQuerySearchCriteria.servicerNumber;

    if ((loanNumber === '' || loanNumber == null) && (servicerNumber === '' || servicerNumber == null || servicerNumber === 'ALL')) {
      errorMessages.push(this.utilService.stringReplace(Constants.REQUIRED_FIELDS_VALIDATION, 'Loan Number', 'Servicer Number'));
    }

    /** Loan Number Validation */
    const loanNumberDigit = /^\d+$/.test(loanNumber);
    if (loanNumber !== '' && loanNumber != null) {
      if (loanNumber.length !== 10 || loanNumberDigit !== true || !loanNumber.startsWith('6')) {
        errorMessages.push(Constants.NOT_VALID_LOAN_NUMBER);
      }
    }

    /** Servicer Number Validation */
    const servicerNumberDigit = /^\d+$/.test(servicerNumber);
    if (servicerNumber !== '' && servicerNumber != null && servicerNumber !== 'ALL') {
      if (servicerNumber.length !== 9 || servicerNumberDigit !== true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_FORMAT, 'Servicer Number', '9'));
      }
    }

    /** Transaction Status Validation */
    const status = transactionQuerySearchCriteria.transactionStatus;

    if (status !== '' && status != null) {
      if (this.utilService.isContainIllegalChar(status) === true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_CHARACTERS, 'Transaction Status', ''));
      }
    }

    /** Product Type Validation */
    const productType = transactionQuerySearchCriteria.productType;

    if (productType !== '' && productType != null) {
      if (this.utilService.isContainIllegalChar(productType) === true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_CHARACTERS, 'Product Type', ''));
      }
    }

    /** Action Code Validation */
    const actionCode = transactionQuerySearchCriteria.actionCode;

    if (actionCode !== '' && actionCode != null) {
      if (this.utilService.isContainIllegalChar(actionCode) === true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_CHARACTERS, 'Action Code', ''));
      }
    }

    /** Transaction Designator Validation */
    const tranDesignator = transactionQuerySearchCriteria.tranDesignator;

    if (tranDesignator !== '' && tranDesignator != null) {
      if (this.utilService.isContainIllegalChar(tranDesignator) === true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_CHARACTERS, 'Transaction Designator', ''));
      }
    }

    /** Sort By Validation */
    const sortBy = transactionQuerySearchCriteria.sortBy;

    if (sortBy !== '' && sortBy != null) {
      if (this.utilService.isContainIllegalChar(sortBy) === true) {
        errorMessages.push(this.utilService.stringReplace(Constants.INVALID_CHARACTERS, 'Sort By', ''));
      }
    }

    return errorMessages;
  }

  // Method for on key enter submit
  trackKeyPress(e) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.queryTransationList();}
  }

}

